import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../account/components/ProtectedRoute";
import { DashboardLayout } from "./components/DashboardLayout";
import { DashboardOverviewPage } from "./pages/DashboardOverviewPage";
import { DashboardSettingsPage } from "./pages/DashboardSettingsPage";
import { MembershipPage } from "./pages/MembershipPage";
import { PaymentHistoryPage } from "./pages/PaymentHistoryPage";
import { PlayerReportPage } from "./pages/PlayerReportPage";
import { UpcomingSessionsPage } from "./pages/UpcomingSessionsPage";

export function DashboardRoutes() {
  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allow={["parent"]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardOverviewPage />} />
        <Route path="sessions" element={<UpcomingSessionsPage />} />
        <Route path="membership" element={<MembershipPage />} />
        <Route path="payments" element={<PaymentHistoryPage />} />
        <Route path="settings" element={<DashboardSettingsPage />} />
        <Route path="players/:playerId/report" element={<PlayerReportPage />} />
      </Route>
    </Routes>
  );
}
